import { IconKeys } from 'components/ui/atoms/icons/types';

type StatsBarContent = {
  title: string;
  value: string;
  icon: IconKeys;
};

export const statsBarContent: StatsBarContent[] = [
  {
    title: '86m+',
    value: 'Global learner network',
    icon: 'planet',
  },
  {
    title: '4,600+',
    value: 'Courses and programs',
    icon: 'list',
  },
];
